<template>
    <div class="row justify-content-center align-items-center pt-3" v-if="hasPagination">

        <div class="col-3 col-md-1 p-md-0 text-start text-md-end">
            <Link v-if="!isFirstPage" :href="getPrevUrl" type="button" class="btn btn-dark">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
                </svg>
            </Link>
            <button v-else type="button" class="btn btn-dark" disabled>
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
                </svg>
            </button>
        </div>

        <div class="col-6 col-md-1 text-center p-md-0">
            {{getCurrentPage}} / {{ getLastPage }}
        </div>

        <div class="col-3 col-md-1 p-md-0 text-end text-md-start">
            <Link v-if="!isLastPage" :href="getNextUrl" type="button" class="btn btn-dark">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
                </svg>
            </Link>
            <button v-else type="button" class="btn btn-dark" disabled>
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
                </svg>
            </button>
        </div>

    </div>
</template>

<script setup lang="ts">
import { Link } from "@inertiajs/vue3";
import {computed} from "vue";
import type {PaginationPropsInterface} from "@/components/helpers/Interfaces.ts";

const { pagination } = defineProps<{
    pagination: PaginationPropsInterface
}>()

const getCurrentPage = computed((): number => pagination.currentPage || 1)
const getLastPage = computed((): number => pagination.lastPage || 1)
const hasPagination = computed((): boolean => pagination.lastPage > 1)
const getPrevUrl = computed((): string => pagination.prevPageUrl || '')
const getNextUrl = computed((): string => pagination.nextPageUrl || '')
const isFirstPage = computed((): boolean => pagination.currentPage ===  1)
const isLastPage = computed((): boolean => (pagination.currentPage || 1) >= (pagination.lastPage || 1))

</script>

<style scoped>
    .h-6{
        height: 1.5rem; /* 24px */
    }

    .w-6{
        width: 1.5rem; /* 24px */
    }
</style>
